<template>
  <div :class="containerClass">
    <a
      class="map-tip"
      href="https://docs.zhugeio.com/questions/map_test.html"
      target="_blank"
      @click="onClickTestLink"
      >测试地图</a
    >
    <span class="overview-fullscreen" @click="onToggleFullScreen"
      ><i :class="fullscreen ? 'cicon-fullscreen_exit' : 'cicon-fullscreen'"></i
    ></span>
    <div class="overview-map-container">
      <overview-map
        ref="map"
        :provinceData="onlineData.province"
        :countryData="onlineData.country"
      ></overview-map>
    </div>
    <div class="overview-fix">
      <div>
        <view-panel class="w1 online-num" title="实时在线人数">
          <number-board
            :val="onlineData.count || 0"
            :style="countStyle"
          ></number-board
          ><span>人</span>
        </view-panel>
        <pv-trend class="w2" :store="hourTrend"></pv-trend>
      </div>
      <div v-if="chartTypeReady">
        <fix-target
          class="w1"
          title="访问终端"
          field="terminal"
          :defaultType="chartType.terminal || 'pie'"
          :store="onlineData.plat"
        ></fix-target>
        <fix-target
          class="w1"
          title="实名/匿名"
          field="anonymous"
          :defaultType="chartType.anonymous || 'bar'"
          :store="onlineData.isAnonymous"
        ></fix-target>
        <fix-target
          class="w1"
          title="来源渠道"
          field="channel"
          :defaultType="chartType.channel || 'pie'"
          :store="onlineData.channel"
        ></fix-target>
      </div>
      <realtime-behaviours
        ref="events"
        class="w3"
        @search="onSearch"
        @ignore="onIgnore"
      ></realtime-behaviours>
    </div>
    <div class="overview-custom">
      <span class="toggle-map-btn">
        <span @click="onToggleMap('china')"><i class="icon-add-thin"></i></span>
        <span @click="onToggleMap('world')">━</span>
      </span>
      <div class="title">今日</div>
      <div
        class="custom-banner"
        v-for="(row, i) in configs"
        :key="'custom-row' + i"
      >
        <template v-for="(target, j) in row">
          <dataview-add-btn
            v-if="target.isAdd"
            :index="j"
            :key="'add' + i + j"
          ></dataview-add-btn>
          <div
            v-else-if="target.isEmpty"
            class="custom-item item-empty"
            :style="'flex: ' + target.flex"
            :key="'empty' + i + j"
          ></div>
          <target
            v-else
            :ref="'target_' + target.id"
            :config="target"
            :key="target.id"
            :store="customStore[target.id]"
            @afterDel="getCustomTargets"
          ></target>
        </template>

        <template v-if="row.length < 6"> </template>
      </div>
    </div>
  </div>
</template>

<script>
import ViewPanel from './panel'
import PvTrend from './pvTrend'
import FixTarget from './fixTarget'
import target from './customTarget'
import realtimeBehaviours from './realtimeBehaviours'
import overviewMap from './map'
import DataviewAddBtn from './addTarget'
import NumberBoard from '../../components/numberBoard'
import io from 'socket.io-client'
import { actions } from '../../store/constants'
import { mapState } from 'vuex'
let socket = null
export default {
  name: 'dataviewAnalysis',
  components: {
    ViewPanel,
    PvTrend,
    FixTarget,
    realtimeBehaviours,
    overviewMap,
    target,
    DataviewAddBtn,
    NumberBoard
  },
  props: {
    socketUrl: {
      type: String,
      default: 'https://static2-online.zhugeio.com'
    }
  },
  data () {
    const data = {
      hourTrend: null,
      onlineData: {
        count: 0,
        plat: null,
        isAnonymous: null,
        channel: null,
        country: null,
        province: null
      },
      chartTypeReady: false,
      chartType: {},
      fullscreen: false,
      interval: null,
      customStore: {},
      timeout: {
        hourTrend: null,
        realtime: null
      },
      eventInterval: null
    }
    return data
  },
  computed: {
    ...mapState({
      configs (state) {
        let res = []
        let row = []
        if (!state.bizDataview.config || !state.bizDataview.config.length) {
          return [
            [
              {
                isAdd: true
              },
              {
                isEmpty: true,
                flex: 5
              }
            ]
          ]
        }
        state.bizDataview.config.forEach(config => {
          row.push(config)
          if (row.length >= 6) {
            res.push(row.map(item => item))
            row = []
          }
        })
        if (row.length) res.push(row.map(item => item))
        const lastRow = res.length ? res[res.length - 1] : []
        if (lastRow.length < 6) {
          lastRow.push({
            isAdd: true
          })
          if (lastRow.length < 6) {
            lastRow.push({
              isEmpty: true,
              flex: 6 - lastRow.length
            })
          }
        } else {
          res.push([
            {
              isAdd: true
            },
            {
              isEmpty: true,
              flex: 5
            }
          ])
        }
        return res
      },
      ignoreLength (state) {
        return state.bizDataview.ignores.length
      },
      canTrack (state) {
        return this.chartTypeReady && state.bizDataview.ready.ignores
      }
    }),
    countStyle () {
      const style = {}
      if (this.onlineData.count >= 10000000) {
        style['font-size'] = '27px !important'
      } else if (this.onlineData.count >= 1000000) {
        style['font-size'] = '30px !important'
      }
      return style
    },
    containerClass () {
      return {
        'realtime-overview': true,
        fullscreen: this.fullscreen
      }
    }
  },
  watch: {
    $route () {
      this.onlineData = {
        plat: null,
        isAnonymous: null,
        channel: null,
        country: null,
        province: null
      }
      this.hourTrend = null
      this.$refs.events.reset()
      socket.disconnect()
      this.init()
    },
    canTrack (flag) {
      if (flag) {
        window.track('数据概览-进入', {
          访问终端: this.chartType.terminal,
          '实名/匿名': this.chartType.anonymous,
          来源渠道: this.chartType.channel,
          实时行为忽略事件: this.ignoreLength
        })
      }
    }
  },
  mounted () {
    this.init()
    this.getDefaultChartType()
  },
  beforeDestroy () {
    clearInterval(this.eventInterval)
    clearInterval(this.interval)
    clearTimeout(this.timeout.hourTrend)
    clearTimeout(this.timeout.realtime)
    socket.disconnect()
    socket = null
  },
  methods: {
    onToggleMap (type) {
      this.$refs.map.toggleMap(type)
    },
    init () {
      this.getConfig()
      socket = io.connect(this.socketUrl, {
        path: '/ns'
      })
      socket.on('hourTrend', data => {
        this.hourTrend = data
        this.timeout.hourTrend = setTimeout(() => {
          this.getHourTrend()
        }, 60 * 60 * 1000) // 一个小时更新一次
      })
      socket.on('realtime', data => {
        this.onlineData = data
        this.timeout.realtime = setTimeout(() => {
          this.getRealTimeData()
        }, 20000) // 20秒请求一次
      })
      let canUpdate = true
      this.eventInterval = setInterval(() => {
        canUpdate = true
      }, 3000)
      socket.on('event', event => {
        if (this.$refs.events && canUpdate) {
          this.$refs.events.receiveEvent(event)
          canUpdate = false
        }
      })
      socket.on('dataview:custom', res => {
        this.$set(this.customStore, res.id, res.data)
      })
      socket.on('err', data => {
        console.error('socket通信错误', data)
      })
      socket.on('connect', () => {
        this.getHourTrend()
        this.getRealTimeData()
        this.getRealEvents()
        this.getCustomTargets()
        this.interval = setInterval(() => {
          this.getCustomTargets()
        }, 30000) // 30秒一次
      })
    },
    getConfig () {
      this.$store.dispatch(actions.dataview.getConfig, {
        appId: this.appId,
        plat: this.platform
      })
    },
    getDefaultChartType () {
      this.$store
        .dispatch(actions.dataview.queryChartType, this.appId)
        .then(res => {
          this.chartType = res.data || {}
        })
        .catch(err => {
          console.error('获取默认图表类型失败', err)
        })
        .finally(() => {
          this.chartTypeReady = true
        })
    },
    getHourTrend () {
      socket.emit('hourTrend', {
        appId: this.appId,
        plat: this.platform
      })
    },
    getRealTimeData () {
      socket.emit('realtime', {
        appId: this.appId,
        plat: this.platform
      })
    },
    getRealEvents () {
      socket.emit('event', {
        appId: this.appId
      })
    },
    afterAddCustom () {
      this.getCustomTargets()
    },
    getCustomTargets () {
      if (socket) {
        socket.emit('custom', {
          appId: this.appId,
          plat: this.platform
        })
      }
    },
    onSearch (val) {
      socket.emit('filterEvent', val)
    },
    onIgnore (ids) {
      window.track('实时概览-忽略事件')
      socket.emit('ignoreEvent', ids)
    },
    onToggleFullScreen () {
      this.fullscreen = !this.fullscreen
      if (this.fullscreen) {
        window.track('实时概览-全屏')
      }
      this.$refs.map.resize()
      document.querySelector('.intercom-lightweight-app').style.display = this
        .fullscreen
        ? 'none'
        : 'block'
    },
    onClickTestLink () {
      window.track('实时概览-测试地图链接')
    }
  }
}
</script>

<style lang="sass">
@import './styles/index'
</style>
